import { WithEnterpriseId } from '@mews-commander/types';
import {
    Card,
    ModalWrapper,
    NewModalBodyWrapper,
    OptimusProvider,
    PageHeader,
    QueryBoundary,
    useBreadcrumbs,
} from '@mews-commander/ui';
import { Container } from '@optimus-web/core';
import { CancelReservationsForm } from './form/CancelReservationsForm';

export const CancelReservations = ({ enterpriseId }: WithEnterpriseId) => {
    const breadcrumbs = useBreadcrumbs();

    return (
        <OptimusProvider density="spacious">
            <ModalWrapper>
                <PageHeader breadcrumbs={breadcrumbs} />
                <NewModalBodyWrapper>
                    <QueryBoundary loader="overlay">
                        <Container align="center" maxWidth="500px" padding={['200', '0']}>
                            <Card padding="300">
                                <CancelReservationsForm enterpriseId={enterpriseId} />
                            </Card>
                        </Container>
                    </QueryBoundary>
                </NewModalBodyWrapper>
            </ModalWrapper>
        </OptimusProvider>
    );
};
